import * as React from 'react';
import CardContainer from '../../../components/CardContainer';
import { Button, Form, Input, message } from 'antd';
import Devider from '../../../components/Devider';
import BusinessModel from '../models/BusinessModel';
import { observer } from 'mobx-react-lite';
import FoundBusinessPanel from './FoundBusinessPanel';
import NotFoundBusinessPanel from './NotFoundBusinessPanel';
import StepperFooter from '../../../components/StepperFooter';
import AntdForms from '../../../services/AntdForms';
import { useTranslation } from 'react-i18next';
import SessionForm from '../../../components/forms/SessionForm';
import { WIZARD_STEPS } from '../../wizard-steps-description';
import StepperModel from '../../../models/StepperModel';
import Step from '../Step';
import WebsitePopup from './WebsitePopup';
import StepLoaderWrapper from '../../../components/StepLoaderWrapper';
import { RightOutlined } from '@ant-design/icons';
import ScreenRenderer from './ScreenRenderer';

interface FCProps { }

const Index: React.FC<FCProps> = observer(({ }) => {
  const [form] = Form.useForm();
  const [loadingNextStep, setLoadingNextStep] = React.useState(false);
  const { t } = useTranslation();

  const collectFormData = React.useCallback((formData) => {
    let selectedBusiness = BusinessModel.getSelectedBusiness();

    /**
     * Get business category name
     * ---------------------------------------------------------------
     */
    let businessCategoryName = '';
    // [1] check if business is found and category is selected
    if (
      selectedBusiness &&
      formData.get('foundBusinessForm')?.['businessCategoryName']
    ) {
      businessCategoryName =
        formData.get('foundBusinessForm')?.['businessCategoryName'];
    }
    // [2] check if business is found and category is not selected
    else if (selectedBusiness) {
      businessCategoryName = BusinessModel.selectedCategoryName;
    }

    // [3] check if business is not found
    if (formData.has('notFoundBusinessForm')) {
      businessCategoryName = formData.get('notFoundBusinessForm')?.[
        'businessCategoryName'
      ];
    }

    /**
     * Get website domain
     * ---------------------------------------------------------------
     */

    let websiteDomain = null;
    if (formData.has('notFoundBusinessForm')) {
      websiteDomain = formData.get('notFoundBusinessForm')?.['website'];
    }

    /**
     * Get company name
     * ---------------------------------------------------------------
     */
    let companyName = '';

    if (selectedBusiness) {
      companyName = selectedBusiness.name;
    } else {
      companyName = formData.get('notFoundBusinessForm')?.['companyName'];
    }

    /**
     * Get zip code
     * ---------------------------------------------------------------
     */
    let zipCode = '';

    if (selectedBusiness) {
      zipCode = selectedBusiness.zipCode;
    } else {
      zipCode = formData.get('notFoundBusinessForm')?.['zip'];
    }

    /**
     * Get address
     * ---------------------------------------------------------------
     */
    let address = '';

    if (selectedBusiness) {
      address = selectedBusiness.address;
    } else {
      address =
        formData.get('notFoundBusinessForm')?.['street'] +
        ' ' +
        formData.get('notFoundBusinessForm')?.['streetNumber'] +
        ',' +
        formData.get('notFoundBusinessForm')?.['city'];
    }

    /**
     * Get street name
     * ---------------------------------------------------------------
     */
    let street = '';

    if (selectedBusiness) {
      street = selectedBusiness.street;
    } else {
      street = formData.get('notFoundBusinessForm')?.['street'];
    }

    /**
     * Get street number
     * ---------------------------------------------------------------
     */
    let state = '';

    if (selectedBusiness) {
      state = selectedBusiness.state;
    } else {
      state = formData.get('notFoundBusinessForm')?.['state'];
    }

    /**
     * Get city
     * ---------------------------------------------------------------
     */
    let city = '';

    if (selectedBusiness) {
      city = selectedBusiness.city;
    } else {
      city = formData.get('notFoundBusinessForm')?.['city'];
    }

    /**
     * Get country
     * ---------------------------------------------------------------
     */
    let country = '';

    if (selectedBusiness) {
      country = selectedBusiness.country;
    } else {
      country = formData.get('notFoundBusinessForm')?.['country'];
    }

    /**
     * get phone number
     * ---------------------------------------------------------------
     */
    let phone = '';

    if (selectedBusiness) {
      phone = selectedBusiness.phoneNumber;
    } else {
      phone = formData.get('notFoundBusinessForm')?.['phone'];
    }

    /**
     * get type of the domain (existing or new)
     * ---------------------------------------------------------------
     */
    let domainType = '';
    if (formData.has('notFoundBusinessForm')) {
      domainType = formData.get('notFoundBusinessForm')?.['doesUserHasWebsite'];
    }

    return {
      businessCategoryName,
      websiteDomain,
      companyName,
      zipCode,
      address,
      street,
      state,
      city,
      country,
      phone,
      domainType
    };
  }, []);

  // mobx reactivity
  BusinessModel.businessLoading;

  return (
    <CardContainer>
      <div>
        <ScreenRenderer />
      </div>
    </CardContainer>
  );
});

export default Index;
